import { collectionConstants } from '../../_constants';

export function collection(state = {}, action) {
    switch (action.type) {
        case collectionConstants.RESET:
            return {}
        case collectionConstants.COLLECTION_FETCHING:
            return {
                ...state,
                collectionFetching: true
            };
        case collectionConstants.COLLECTION_FETCHED:
            return {
                ...state,
                collectionFetching: false
            };
        case collectionConstants.COLLECTION_SUBMITTING:
            return {
                ...state,
                collectionSubmitting: true
            };
        case collectionConstants.COLLECTION_SUBMITTED:
            return {
                ...state,
                collectionSubmitting: false
            };
        case collectionConstants.GET_WAYBILL_FOR_COLLECTION: {
            return {
                ...state,
                wbCollection: action.wbCollection
            }
        }
        case collectionConstants.GET_WAYBILL_FOR_COLLECTION_OTHER_CHARGE: {
            return {
                ...state,
                wbCollectionOther: action.wbCollectionOther
            }
        }
        case collectionConstants.LOAD_COLLECTION: {
            return {
                ...state,
                collectionDatas: action.collectionDatas
            }
        }
        case collectionConstants.GET_COLLECTION_BY_ID: {
            return {
                ...state,
                collectionById: action.collectionById
            }
        }
        case collectionConstants.GET_COLLECTION_BY_ID_OTHERCHARGE: {
            return {
                ...state,
                collectionByIdOtherCharge: action.collectionByIdOtherCharge
            }
        }
        case collectionConstants.CALCULATED_CWT: {
            return {
                ...state,
                calculatedCwt: action.calculatedCwt
            }
        }
        case collectionConstants.EXCESS_PAY_GL: {
            return {
                ...state,
                excessPayGL: action.excessPayGL
            }
        }
        case collectionConstants.OTHER_INCOME_ACCOUNT: {
            return {
                ...state,
                OtherInAcct: action.OtherInAcct
            }
        }
        case collectionConstants.GENERATE_RECEIPT: {
            return {
                ...state,
                generatedReceipt: action.generatedReceipt
            }
        }
        default:
            return state;
    }
}